/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Ad_Template_NameInputs */



/**
* | output |
* | --- |
* | "AD Template 0{index}" |
*
* @param {Ad_Template_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_name = /** @type {((inputs: Ad_Template_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Modèle AD 0${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`AD-Vorlage 0${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Modello di annuncio 0${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Шаблон объявления 0${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Plantilla de anuncio 0${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`广告模板 0${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`広告テンプレート 0${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`AD टेम्पलेट 0${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Modelo de anúncio 0${i?.index}`)
	return /** @type {LocalizedString} */ (`AD Template 0${i?.index}`)
});